export default `
uniform float uTime;
uniform float uRandomScalar;
uniform float uMouseMovementAmount;
uniform float uVerticalTilt;
uniform bool uIsFront;
uniform float uIndex;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;

varying vec3 vPosition;
varying vec3 vWorldPosition;

const float PI = 3.141592653589793;

mat2 rotate2D (float angle) {
  float s = sin(angle);
  float c = cos(angle);
  return mat2(c, -s, s, c);
}


vec3 center = vec3(0.0);
vec3 globalCenter = vec3(0.0);


float easeInCirc(float t) {
  return 1.0 - sqrt(1.0 - t * t);
}

vec3 getCenter(float y, vec3 _center, float legProgress) {
  float phase = y * 1.5 - uTime * 2.5;

  float waveI = uIsFront ? 0.1 : (uIndex == 0.0) ? 0.2 :  0.12;
  float waveI2 = waveI;

  waveI *= mix(1.0, 2.0, uMouseMovementAmount);
  waveI2 *= mix(0.0, 1.0, smoothstep(0.0, 0.2, uMouseMovementAmount));

  float waveF_z = 2.0;

  float circIndencity = 2.0;

  return _center + vec3(
    sin(-phase * 4.0) * 0.6 * waveI2 * legProgress,
    y,
    cos(phase * waveF_z) * waveI * legProgress
    -easeInCirc(y * 0.6) * waveI2 * circIndencity
  );
}

vec3 getWholeCenter(float y, float intensity) {
  return globalCenter + vec3(
    0.0,
    y,
    -easeInCirc(y * 0.6) * intensity
  );
}

vec3 bendWhole(vec3 worldPos) {
  float intensity = 6.0;
  intensity *= mix(0.0, 0.8, smoothstep(0.0, 0.3, uMouseMovementAmount)) * uVerticalTilt;

  float y = (worldPos.y - globalCenter.y) * mix(1.0, 0.9, uVerticalTilt);

  vec3 distanceFromCenter = vec3(
    worldPos.x - globalCenter.x,
    0.0,
    worldPos.z - globalCenter.z
  );

  float eps = 0.1;

  vec3 prevCenter = getWholeCenter(y - eps, intensity);
  vec3 currentCenter = getWholeCenter(y, intensity);
  vec3 nextCenter = getWholeCenter(y + eps, intensity);

  vec3 T = normalize(nextCenter - prevCenter);
  vec3 B = normalize(cross(vec3(1.0, 0.0, 0.0), T));
  vec3 N = normalize(cross(T, B));

  return currentCenter
    + N * distanceFromCenter.x
    + B * distanceFromCenter.z;
}


void main(){
  vUv = uv;
  vNormal = normal;
  vNormal2 = normalize(normalMatrix * normal);
  vPosition = position;
  vec3 pos = position;

  float legProgress = smoothstep(0.0, -2.0, pos.y);
  if(uIndex != 0.0){
    legProgress = pow(legProgress, 2.0);
  }

  // Offset from the original centerline
  vec3 distanceFromCenter = vec3(
    pos.x - center.x,
    0.0,
    pos.z - center.z
  );

  float eps = 0.05;

  // Deformed centerline
  vec3 prevCenter = getCenter(pos.y - eps, center, legProgress);
  vec3 currentCenter = getCenter(pos.y, center, legProgress);
  vec3 nextCenter = getCenter(pos.y + eps, center, legProgress);

  // Tangent
  vec3 T = normalize(nextCenter - prevCenter);

  // Local coordinate frame
  vec3 B = normalize(cross(vec3(1.0, 0.0, 0.0), T));
  vec3 N = normalize(cross(T, B));

  // Reconstruct the tube
  vec3 transformed = currentCenter
    + N * distanceFromCenter.x
    + B * distanceFromCenter.z;

  pos = transformed;

  pos.zy = rotate2D(0.05) * pos.zy;
  pos.xz = rotate2D(((uIndex) / 5.0) * 2.0 * PI) * pos.xz;

  float zOffset = (uIsFront ? 0.0 : 0.1) * legProgress;

  pos.z += zOffset;
  pos = bendWhole(pos);
  pos.z -= zOffset;

  vec4 worldPos = modelMatrix * vec4(pos, 1.0);
  vec4 screenPos = projectionMatrix * viewMatrix * worldPos;
  vWorldPosition = worldPos.xyz;

  gl_Position = screenPos;
}
`
